import React, { useEffect, useState } from "react";
import Controls from "../controls/controls";
import RagBanner from "../rag-banner/rag-banner";
import { GlobalContext } from "../../context/global.context";
import { useContext } from "react";
import "./hero.scss";

const Hero = () => {
  const { isPlaying, isLoading, routine, activeRoutine, convertIntervalToLocal } = useContext(GlobalContext);

  return (
    <section className="hero" id="home">
      <header className="hero__header">
        <div className="hero__header__logo">
          <img
            src={`/img/${isLoading ? "logo_animation.gif" : "logo.png"}`}
            alt="phatbeatz logo"
          />
        </div>
        <nav className="hero__header__nav">
          <ul className="hero__header__nav__links">
            <li><a href="#home">home</a></li>
            <li><a href="#routine">routine</a></li>
            <li><a href="#about">about</a></li>
          </ul>
        </nav>
      </header>

      <RagBanner className="hero__rag" />

      <Controls
        className="hero__controls"
        btnClassName="hero__controls__btn"
      />

      <div className="hero__turntable">
        <img
          src={`/img/${isPlaying || isLoading ? "turntable_animation.gif" : "turntable_start.png"}`}
          alt="turntable"
        />
      </div>

      <div className="hero__crate">
        <img src="/img/CRATE_REC_1.png" alt="record crate" />
      </div>

      <div className="hero__storefront">
        <img src="/img/store_front_4.png" alt="store front" />
      </div>

      <div className="hero__schedule" id="routine">
        <h2 className="hero__schedule__title">Daily Routine:</h2>
        <ul className="hero__schedule__list">
          {routine.map((item) => {
            const isActive = activeRoutine && activeRoutine.time === item.time;
            const localTime = convertIntervalToLocal ? convertIntervalToLocal(item.time) : item.time;
            return (
              <li 
                key={item.time} 
                className={`hero__schedule__item ${isActive ? 'hero__schedule__item--active' : ''}`}
              >
                <span className="hero__schedule__time">{localTime}</span>
                <span className="hero__schedule__name">
                  {item.title}
                  {item.description && <span className="hero__schedule__desc">: {item.description}</span>}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Hero;
